var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8066 7.62337L20.1842 6.54328C19.6576 5.62936 18.4907 5.31408 17.5755 5.83847V5.83847C17.1399 6.0951 16.6201 6.16791 16.1307 6.04084C15.6413 5.91378 15.2226 5.59727 14.9668 5.16113C14.8023 4.8839 14.7139 4.56815 14.7105 4.2458V4.2458C14.7254 3.72898 14.5304 3.22816 14.17 2.85743C13.8096 2.48669 13.3145 2.27762 12.7975 2.27783H11.5435C11.0369 2.27783 10.5513 2.47967 10.194 2.8387C9.83666 3.19773 9.63714 3.68435 9.63958 4.19088V4.19088C9.62457 5.23668 8.77245 6.07657 7.72654 6.07646C7.40418 6.07311 7.08843 5.9847 6.8112 5.82017V5.82017C5.89603 5.29577 4.72908 5.61105 4.20251 6.52497L3.53432 7.62337C3.00838 8.53615 3.31937 9.70236 4.22997 10.2321V10.2321C4.82187 10.5738 5.1865 11.2053 5.1865 11.8888C5.1865 12.5723 4.82187 13.2038 4.22997 13.5456V13.5456C3.32053 14.0717 3.0092 15.2351 3.53432 16.1451V16.1451L4.16589 17.2344C4.41262 17.6795 4.82657 18.0081 5.31616 18.1472C5.80575 18.2863 6.33061 18.2247 6.77459 17.9758V17.9758C7.21105 17.7211 7.73116 17.6513 8.21931 17.782C8.70746 17.9126 9.12321 18.2328 9.37413 18.6714C9.53867 18.9486 9.62708 19.2644 9.63043 19.5868V19.5868C9.63043 20.6433 10.4869 21.4998 11.5435 21.4998H12.7975C13.8505 21.4998 14.7055 20.6489 14.7105 19.5959V19.5959C14.7081 19.0878 14.9088 18.5998 15.2681 18.2405C15.6274 17.8812 16.1154 17.6804 16.6236 17.6829C16.9451 17.6915 17.2596 17.7795 17.5389 17.9392V17.9392C18.4517 18.4651 19.6179 18.1541 20.1476 17.2435V17.2435L20.8066 16.1451C21.0617 15.7073 21.1317 15.1858 21.0012 14.6961C20.8706 14.2065 20.5502 13.7891 20.111 13.5364V13.5364C19.6717 13.2837 19.3514 12.8663 19.2208 12.3767C19.0902 11.8871 19.1602 11.3656 19.4153 10.9277C19.5812 10.6381 19.8213 10.398 20.111 10.2321V10.2321C21.0161 9.70265 21.3264 8.54325 20.8066 7.63252V7.63252V7.62337Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.175,
    cy: 11.8886,
    r: 2.63616,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsEmpty);
export default __webpack_public_path__ + "static/media/settings_empty.2b6dc1514b1926a4796af459f0336d05.svg";
export { ForwardRef as ReactComponent };